const API_URL = import.meta.env.VITE_API_URL || "http://localhost:4000/api/v1";
let activeApiRequests = 0;

function flattenIssueMessages(node) {
  if (!node) {
    return [];
  }

  if (Array.isArray(node)) {
    return node.flatMap(flattenIssueMessages);
  }

  if (typeof node === "object") {
    return Object.values(node).flatMap(flattenIssueMessages);
  }

  if (typeof node === "string") {
    return [node];
  }

  return [];
}

function getErrorMessage(payload) {
  const issueMessages = [
    ...flattenIssueMessages(payload?.issues?.fieldErrors),
    ...flattenIssueMessages(payload?.issues?.formErrors),
    ...flattenIssueMessages(payload?.fieldErrors),
    ...flattenIssueMessages(payload?.errors),
  ].filter(Boolean);

  if (issueMessages.length > 0) {
    return issueMessages[0];
  }

  return payload?.message || "Request failed";
}

function emitApiLoadingChange() {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent("metora:api-loading", {
      detail: { isLoading: activeApiRequests > 0, activeRequests: activeApiRequests },
    }),
  );
}

function beginApiRequest() {
  activeApiRequests += 1;
  emitApiLoadingChange();
}

function endApiRequest() {
  activeApiRequests = Math.max(0, activeApiRequests - 1);
  emitApiLoadingChange();
}

export function getToken() {
  return localStorage.getItem("metora_token");
}

export function setToken(token) {
  localStorage.setItem("metora_token", token);
}

export function clearToken() {
  localStorage.removeItem("metora_token");
}

export async function apiFetch(path, options = {}) {
  const {
    teamId: requestedTeamId,
    token: requestedToken,
    showGlobalLoading = true,
    ...fetchOptions
  } = options;
  const isFormData = typeof FormData !== "undefined" && fetchOptions.body instanceof FormData;
  const headers = {
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    ...(fetchOptions.headers || {}),
  };
  const token = requestedToken !== undefined ? requestedToken : getToken();
  const teamId = requestedTeamId || localStorage.getItem("metora_team_id");

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (teamId) {
    headers["x-team-id"] = teamId;
  }

  if (showGlobalLoading) {
    beginApiRequest();
  }

  try {
    const response = await fetch(`${API_URL}${path}`, {
      ...fetchOptions,
      headers,
      body: !fetchOptions.body
        ? undefined
        : isFormData
          ? fetchOptions.body
          : JSON.stringify(fetchOptions.body),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ message: "Request failed" }));
      const message = getErrorMessage(error);
      const requestError = new Error(message);
      requestError.payload = error;
      throw requestError;
    }

    if (response.status === 204) {
      return null;
    }
    const contentType = response.headers.get("content-type") || "";

    if (contentType.includes("application/pdf")) {
      return response.blob();
    }

    return response.json();
  } finally {
    if (showGlobalLoading) {
      endApiRequest();
    }
  }
}
